export const INITIAL_CENTER = { lat: 0, lng: 0 };
export const DETAILS_LIMIT = 5;

export const GEOFENCE_STYLE = {
  fillColor: 'red',
  fillOpacity: 0.1,
  strokeColor: 'red',
  strokeOpacity: 0.2,
  strokeWeight: 1,
  cursor: 'grab',
  zindex: 989,
};

export const DRAWER_MANAGER_OPTIONS = {
  // editable: true,
  fillColor: '#ffc000',
  fillOpacity: 0.2,
  strokeColor: '#FF0000',
  strokeOpacity: 0.8,
  strokeWeight: 1,
  cursor: 'grab',
  zindex: 989,
};

export const MIN_GEOFENCE_RADIUS = 5;
export const MIN_GEOFENCE_AREA_SQUARE_METERS = Math.PI * MIN_GEOFENCE_RADIUS ** 2;
